/* Copyright (c) 2017 Backpack Health LLC */

import { authorizedApiRequest } from './apiRequest';
import ApiErrorModel from 'models/ApiErrorModel';
import AppUtils from 'lib/AppUtils';
import userGroupRole from '../constants/userGroupRole';

const api = {
  create: function createNotification() {
    return authorizedApiRequest('post', 'notifications');
  },
  del: function removeNotification(notificationId) {
    return authorizedApiRequest('delete', `notifications/${notificationId}`);
  },
  getAll: function getAllNotifications() {
    return authorizedApiRequest('get', 'notifications');
  },
  accept: function acceptNotification(notificationId) {
    return authorizedApiRequest('put', `notifications/${notificationId}/accept`);
  },
  reject: function rejectNotification(notificationId) {
    return authorizedApiRequest('put', `notifications/${notificationId}/reject`);
  },
  count: function getNotificationsCount() {
    return authorizedApiRequest('get', 'notifications/count', () => {});
  },
  resend: function resendNotification(notificationId) {
    return authorizedApiRequest('put', `notifications/${notificationId}/resend`);
  },
};


const notificationApi = {
  create(notificationData) {
    return api.create()(_.assign({}, { subdomain: AppUtils.getSubdomain() }, notificationData))
    .then(res => res.data.data);
  },
  delNotification(notificationId) {
    return api.del(notificationId)()
    .then(res => null);
  },
  getAll() {
    return api.getAll()()
    .then(res => res.data.data);
  },
  accept(notificationId) {
    return api.accept(notificationId)()
    .then(res => null);
  },
  reject(notificationId) {
    return api.reject(notificationId)()
    .then(res => null);
  },
  count() {
    return api.count()()
    .then(res => res.data.data);
  },
  resend(notificationId, profile_id, subdomain) {
    return api.resend(notificationId)({ profile_id, subdomain })
    .then(res => null);
  },
  inviteGroupAdmin(email, group_id) {
    return api.create()({
      type: 'group_admin',
      group_admin: {
        email,
        role: userGroupRole.VIEWER,
        group_id,
      },
    })
    .then(res => res.data.data);
  },
};

export default notificationApi;
